import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.065 7.311a2.153 2.153 0 0 0-2.15-2.15H14.3v-.538a1.615 1.615 0 0 0-1.613-1.613H7.31a1.615 1.615 0 0 0-1.613 1.613v.538H4.084a2.153 2.153 0 0 0-2.15 2.15v1.614h16.13zm-4.84-2.15H6.774v-.538a.54.54 0 0 1 .538-.538h5.377a.54.54 0 0 1 .537.538zm-.537 5.108a.807.807 0 0 1-.807.806H8.117a.806.806 0 0 1-.806-.806v-.135A.134.134 0 0 0 7.176 10H1.934v4.84a2.15 2.15 0 0 0 2.15 2.15h11.83a2.15 2.15 0 0 0 2.15-2.15V10h-5.242a.135.135 0 0 0-.134.134z"
    }, null, -1)
  ]))]))
}
export default { render: render }